import { OperationResult } from '@vp/common/core/OperationResult';
import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';

export abstract class AccessManagerRepository {
  abstract apply(
    profileId: string,
    changes: ProfileAccessModel,
    controller?: AbortController,
  ): Promise<OperationResult<ProfileAccessModel>>;
}
